import React from 'react';
import closeIcon from '../assets/images/Close.svg'; // Path to your close icon

const Lightbox = ({ media, onClose, currentIndex }) => {
  if (!media || media.length === 0) return null;

  const currentMedia = media[currentIndex];

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        {currentMedia.file_type === 'video' ? (
          <video controls className="lightbox-video">
            <source src={currentMedia.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img src={currentMedia.url} alt="Lightbox" className="lightbox-image" />
        )}
        <button className="lightbox-close" onClick={onClose}>
          <img src={closeIcon} alt="Close" />
        </button>
      </div>
    </div>
  );
};

export default Lightbox;
